import React from "react"; 
import "./PicturePageHeader.css";
import { Link, useLocation } from "react-router-dom";

const PicturePageHeader = () => {
    const location = useLocation();
    
    // Determine the back path based on the current route
    const getBackPath = () => {
        if (location.pathname.includes('/discover/ethereum/nft/')) {
            return '/discover/ethereum';
        } else if (location.pathname.includes('/discover/solana/nft/')) {
            return '/discover/solana';
        } else {
            // Fallback for old /picture/ routes
            return '/discover/ethereum';
        }
    };

    return (
        <div className="pictureHeaderContainer">
            <Link className="galleryLink" to={getBackPath()}>
                <div className="redirectGalleryButtonContainer">
                    <svg className="back-arrow-icon" height="2em" viewBox="0 0 28 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: 'auto', verticalAlign: 'middle' }}>
                        {/* Long, thick horizontal tail that ends at the base of the arrow head */}
                        <path d="M24 12H8" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/>
                        {/* Filled arrow head with curved sides */}
                        <path d="M8 6 Q4 10, 2 12 Q4 14, 8 18 Q6 12, 8 6 Z" fill="currentColor" />
                    </svg>
                    <h3>Gallery</h3>
                </div>
            </Link>
        </div>
    );
}

export default PicturePageHeader;